import * as React from 'react';
import { isBrowser } from '@core/utils/env';

const useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

export default useIsomorphicLayoutEffect;
